module.exports = __webpack_public_path__ + "static/media/me.04c02e58.png";